<template #default>
    <div>
        <div class="mb-0">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-information-outline mr-1"></i>
                Basic Information
            </h6>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">Method</small>
                    <b-badge :variant="getMethodVariant(communicationLog.method)">{{ getMethodText(communicationLog.method) }}</b-badge>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">Used</small>
                    <b-badge :variant="communicationLog.isUsed ? 'success' : 'secondary'">
                        {{ communicationLog.isUsed ? $t('label.yes') : $t('label.no') }}
                    </b-badge>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">User</small>
                    <div class="border rounded bg-light p-2">{{ getUserName(communicationLog.user) }}</div>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">{{ $t('label.createdAt') }}</small>
                    <div class="border rounded bg-light p-2">{{ communicationLog.createdAt || '--' }}</div>
                </div>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-message-text-outline mr-1"></i>
                Purpose
            </h6>
            <div class="border rounded bg-light p-2 text-primary">{{ communicationLog.purpose || '--' }}</div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-email-outline mr-1"></i>
                Recipient
            </h6>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">From</small>
                    <div class="border rounded bg-light p-2">{{ communicationLog.from || '--' }}</div>
                </div>
                <div class="col-md-6 mb-3">
                    <small class="text-muted d-block mb-1">To</small>
                    <div class="border rounded bg-light p-2">{{ communicationLog.to || '--' }}</div>
                </div>
                <div class="col-md-6">
                    <small class="text-muted d-block mb-1">CC</small>
                    <div class="border rounded bg-light p-2">{{ communicationLog.cc || '--' }}</div>
                </div>
                <div class="col-md-6">
                    <small class="text-muted d-block mb-1">BCC</small>
                    <div class="border rounded bg-light p-2">{{ communicationLog.bcc || '--' }}</div>
                </div>
            </div>
        </div>
        <hr>
        <div>
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-code-json mr-1"></i>
                Payload
            </h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <pre class="mb-0">{{ communicationLog.payload ? getJsonText(communicationLog.payload) : '--' }}</pre>
            </div>
        </div>
        <hr>
        <div>
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-code-json mr-1"></i>
                Subject
            </h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                {{ communicationLog.subject || '--' }}
            </div>
        </div>
        <hr>
        <div>
            <h6 class="font-weight-bold text-info mb-3">
                <i class="mdi mdi-email-outline mr-1"></i>
                Content
            </h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <iframe
                    v-if="communicationLog.content"
                    :srcdoc="communicationLog.content"
                    class="w-100 border-0"
                    height="600"
                ></iframe>
                <span v-else>--</span>
            </div>
        </div>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end">
            <b-button
                type="button"
                variant="danger"
                class="col-2"
                @click="$emit('done')"
            >
                {{ $t('label.cancel') }}
            </b-button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        communicationLog: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getJsonText(data) {
            if (typeof data == 'string') {
                try {
                    return JSON.stringify(JSON.parse(data), null, 2);
                } catch (e) {
                    return data;
                }
            }
            return JSON.stringify(data, null, 2);
        },
        getUserName(user) {
            if(!user) return '--';
            return `${user.firstName} ${user.lastName}`;
        },
        getMethodText(method) {
            if(method == 1) return 'email';
            if(method == 2) return 'whatsapp';
            return 'other';
        },
        getMethodVariant(method) {
            if(method == 1) return 'info';
            if(method == 2) return 'success';
            return 'secondary';
        },
    },
}
</script>
